import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetDeliveryArticleByUidApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        slug: z.string(),
        name: z.string(),
        description: z.any(),
        weight: z.number().optional().nullable(),
        price: z.number().optional().nullable(),
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
        elements: z.array(
            z.object({
                name: z.string(),
                value: z.number(),
                meassure: z.string(),
            }),
        ).optional().nullable(),
        currency: z.object({
            name: z.string(),
            abbreviation: z.string(),
        }).optional().nullable(),
        category: z.object({
            name: z.string(),
        }).optional().nullable(),
        tags: z.array(
            z.object({
                name: z.string(),
            }),
        ).optional().nullable(),
        recommendations: z.array(
            z.object({
                documentId: z.string(),
                slug: z.string(),
                name: z.string(),
                weight: z.number().optional().nullable(),
                price: z.number().optional().nullable(),
                images: z.array(
                    z.object({
                        url: z.string(),
                    }),
                ).optional().nullable(),
                currency: z.object({
                    name: z.string(),
                    abbreviation: z.string(),
                }).optional().nullable(),
            }),
        ).optional().nullable(),
    }),
});

type GetDeliveryArticleByUidApiResponse
    = ApiResponse<z.infer<typeof GetDeliveryArticleByUidApiResponseSchema>>
    | BaseError;

type GetDeliveryArticleByUidActionRequest = {
    uid: string,
}

export const getDeliveryArticleByUid = createAsyncThunk<
    GetDeliveryArticleByUidApiResponse,
    GetDeliveryArticleByUidActionRequest
>(
    'DeliveryArticlePageActionsGetDeliveryArticleByUid',
    async ({
        uid,
    }) => apiInstance.get(
        `/s/delivery-articles/${uid}`,
        {
            'populate[images][fields]': 'url',
            'populate[elements][fields]': '*',
            'populate[currency][fields]': '*',
            'populate[category][fields]': '*',
            'populate[tags][fields]': '*',
            'populate[recommendations][fields]': '*',
            'populate[recommendations][populate][0]': 'images',
            'populate[recommendations][populate][1]': 'currency',
            'populate[recommendations][populate][images][fields]': 'url',
            'populate[recommendations][populate][currency][fields]': '*',
        },
        GetDeliveryArticleByUidApiResponseSchema,
    ),
);
